import { Box } from "@mui/material";
import {
	BooleanField,
	Datagrid,
	DateField,
	ExportButton,
	FilterButton,
	List,
	SelectInput,
	TextField,
	TextInput,
	TopToolbar,
	useRecordContext,
} from "react-admin";

const purchaseEventFilters = [
	<TextInput key="appId" label="App ID" source="appId" />,
	<TextInput key="installId" label="Install ID" source="installId" />,
	<TextInput
		key="transactionId"
		label="Transaction ID"
		source="transactionId"
	/>,
	<SelectInput
		key="eventType"
		label="Event Type"
		source="eventType"
		choices={[
			{ id: "initial", name: "Initial" },
			{ id: "renewal", name: "Renewal" },
			{ id: "cancel", name: "Cancel" },
		]}
	/>,
	<SelectInput
		key="processingStatus"
		label="Processing Status"
		source="processingStatus"
		choices={[
			{ id: "pending", name: "Pending" },
			{ id: "processed", name: "Processed" },
			{ id: "failed", name: "Failed" },
		]}
	/>,
	<SelectInput
		key="needsReview"
		label="Needs Review"
		source="needsReview"
		choices={[
			{ id: "true", name: "Yes" },
			{ id: "false", name: "No" },
		]}
	/>,
];

const ListActions = () => (
	<TopToolbar>
		<FilterButton />
		<ExportButton />
	</TopToolbar>
);

const StatusChip = () => {
	const record = useRecordContext();
	if (!record) return null;

	const colors: Record<string, string> = {
		pending: "#ff9800",
		processed: "#4caf50",
		failed: "#f44336",
	};

	return (
		<Box
			sx={{
				display: "inline-block",
				px: 1,
				py: 0.5,
				borderRadius: 1,
				backgroundColor: colors[record.processingStatus] || "#757575",
				color: "white",
				fontSize: "0.75rem",
				fontWeight: 500,
				textTransform: "uppercase",
			}}
		>
			{record.processingStatus}
		</Box>
	);
};

const AmountField = () => {
	const record = useRecordContext();
	if (!record) return null;
	return (
		<span>
			${(record.amountCentsUSD / 100).toFixed(2)} USD
			{record.currency !== "USD" && (
				<span style={{ color: "#666", marginLeft: 4 }}>
					({(record.amountCents / 100).toFixed(2)} {record.currency})
				</span>
			)}
		</span>
	);
};

export const PurchaseEventList = () => (
	<List
		filters={purchaseEventFilters}
		actions={<ListActions />}
		sort={{ field: "eventTime", order: "DESC" }}
	>
		<Datagrid bulkActionButtons={false}>
			<DateField source="eventTime" label="Event Time" showTime />
			<TextField source="eventType" label="Type" />
			<StatusChip />
			<TextField source="appId" label="App ID" />
			<TextField source="installId" label="Install ID" />
			<TextField source="transactionId" label="Transaction ID" />
			<AmountField />
			<BooleanField source="needsReview" label="Needs Review" />
		</Datagrid>
	</List>
);
